import axios, {AxiosError, AxiosResponse} from 'axios';
import {ErrorObject} from 'types';

/**
 * Create an program.
 * @param {"eat" | "gym"} type
 * @param {T} data
 * @return {Promise<T | ErrorObject | undefined>}
 */
export default async function createProgram<T>(type: 'eat' | 'gym', data: T) {
  return axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_BASE_URL}/programs/${type}`,
    data: JSON.stringify(data),
  }).then((response: AxiosResponse<T>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}
